/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Operator_DescriptionInputs */

const en_meta_showcase_operator_description = /** @type {(inputs: Meta_Showcase_Operator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The operator dashboard hotel staff use daily: revenue, occupancy and reservation overview on one screen. Live demo of the back-office module.`)
};

const lv_meta_showcase_operator_description = /** @type {(inputs: Meta_Showcase_Operator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operatora panelis personāla ikdienas darbam: ieņēmumi, noslodze un rezervāciju pārskats vienā ekrānā. Interaktīva pārvaldības moduļa demonstrācija.`)
};

/**
* | output |
* | --- |
* | "The operator dashboard hotel staff use daily: revenue, occupancy and reservation overview on one screen. Live demo of the back-office module." |
*
* @param {Meta_Showcase_Operator_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_operator_description = /** @type {((inputs?: Meta_Showcase_Operator_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Operator_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_operator_description(inputs)
	return en_meta_showcase_operator_description(inputs)
});